<template>
  <div v-bind:class="{ 'dark-mode': (darkTheme && $isHowuku && !$isMida) }">
    <div @click="toggleMinimize" class="minimize-btn" v-if="$isMida">
      <font-awesome-icon class="fa-xs" v-if="!minimized" icon="chevron-left" />
      <font-awesome-icon class="fa-xs" v-else icon="chevron-right" />
    </div>
    <div class="nav-side-menu" :class="{ minimized: minimized && $isMida }">
      <div class="top-container">
        <!-- <div class="no-drag item mb-3 text-center">
        <span class="not-side-button">
          <strong>
            <img
              height="auto"
              width="80px"
              style="background-color: transparent; border: none;"
              class="ml-2 py-3"
              src="https://cdn.howuku.com/images/logo.png"
            />
          </strong>
        </span>
      </div>-->
        <div class="no-drag item">
          <router-link
            to="/"
            class="nav-link cursor-pointer btn-noshadow side-button mx-2"
          >
            <font-awesome-icon class="ml-2 mr-2" icon="arrow-left" />
            <span class="nav-text">{{ t('Dashboard') }}</span>
          </router-link>
        </div>

        <div class="no-drag item category-title mx-2">
          <span class="nav-text">{{ t('Settings') }}</span>
        </div>

        <div
          class="no-drag item"
          :class="{ activebg: $route.name == 'Setting-Profile' }"
        >
          <router-link
            to="/profile"
            class="nav-link cursor-pointer btn-noshadow side-button mx-2"
          >
            <font-awesome-icon class="ml-2 mr-2" icon="user-circle" />
            <span class="nav-text">{{ t('My Profile') }}</span>
          </router-link>
        </div>
        <template v-if="isAdminRole">
          <div
            class="no-drag item"
            :class="{ activebg: $route.name == 'Setting-Company' }"
          >
            <router-link
              to="/company"
              class="nav-link cursor-pointer btn-noshadow side-button mx-2"
            >
              <font-awesome-icon class="ml-2 mr-2" icon="building" />
              <span class="nav-text">{{ t('Company') }}</span>
            </router-link>
          </div>
          <div
            class="no-drag item"
            :class="{ activebg: $route.name == 'Team' }"
          >
            <router-link
              to="/team"
              class="nav-link cursor-pointer btn-noshadow side-button mx-2"
            >
              <font-awesome-icon class="ml-2 mr-2" icon="users" />
              <span class="nav-text">{{ t('User Access') }}</span>
            </router-link>
          </div>
        </template>
        <div
          class="no-drag item"
          :class="{ activebg: $route.name == 'Website' }"
        >
          <router-link
            to="/website"
            class="nav-link cursor-pointer btn-noshadow side-button mx-2"
          >
            <font-awesome-icon class="ml-2 mr-2" icon="shapes" />
            <span class="nav-text">{{ t('Project') }}</span>
          </router-link>
        </div>
        <div
          v-if="isAdminRole"
          class="no-drag item"
          :class="{ activebg: $route.name == 'BlockIp' }"
        >
          <router-link
            to="/block-ip"
            class="nav-link cursor-pointer btn-noshadow side-button mx-2"
          >
            <font-awesome-icon class="ml-2 mr-2" icon="ban" />
            <span class="nav-text">{{ t('Block IP') }}</span>
          </router-link>
        </div>
        <template v-if="isAdminRole">
          <div
            class="no-drag item"
            :class="{ activebg: $route.name == 'Upgrade' }"
          >
            <router-link
              to="/subscription"
              class="nav-link cursor-pointer btn-noshadow side-button mx-2"
            >
              <font-awesome-icon class="ml-2 mr-2" icon="money-bill" />
              <span class="nav-text">{{ t('Subscription') }}</span>
            </router-link>
          </div>
          <div
            v-if="!$isMida && !$isOptimize"
            class="no-drag item"
            :class="{ activebg: $route.name == 'Payment' }"
          >
            <router-link
              to="/payment"
              class="nav-link cursor-pointer btn-noshadow side-button mx-2"
            >
              <font-awesome-icon class="ml-2 mr-2" icon="receipt" />
              <span class="nav-text">{{ t('Payment') }}</span>
            </router-link>
          </div>

          <div
            v-if="$isMida"
            class="no-drag item"
          >
            <a class="nav-link cursor-pointer btn-noshadow side-button mx-2" href="#" @click="$invoicePortal().catch(e => {
              $swal.fire({
                title: 'No subscription',
                text: 'No active subscription. If this is an error, please contact Mida support for assistance.',
                type: 'question',
                confirmButtonColor: '#2167f5'
              })   

            })">
              <font-awesome-icon class="ml-2 mr-2" icon="receipt" />
              <span class="nav-text">{{ t('Invoices') }}</span>
            </a>
          </div>

          <div
            v-if="(!$isMida && $isHowuku && !hasCustomDomain && !excludedPlan.includes($session.get('paid_plan'))) || $session.get('company_id') === 1"
            class="no-drag item"
            :class="{ activebg: $route.name == 'Affiliate' }"
          >
            <router-link
              to="/affiliate-program"
              class="nav-link cursor-pointer btn-noshadow side-button mx-2"
              v-if="this.isHowuku"
            >
              <font-awesome-icon class="ml-2 mr-2" icon="dollar-sign" />
              <span class="nav-text">{{ t('Refer & Earn') }}</span>
            </router-link>
          </div>
          <div
            v-if="(!$isOptimize && $isHowuku && showEarn && !hasCustomDomain && !excludedPlan.includes($session.get('paid_plan')))"
            class="no-drag item"
            :class="{ activebg: $route.name == 'ReferAndEarn' }"
          >
            <router-link
              to="/refer-and-earn"
              class="nav-link cursor-pointer btn-noshadow side-button mx-2"
            >
              <font-awesome-icon class="ml-2 mr-2" icon="gift" />
              <span class="nav-text">{{ t('Get Free Sessions') }}</span>
            </router-link>
          </div>
          <div
            v-if="$isHowuku && isAdminRole && freePlan"
            class="no-drag item"
          >
            <router-link
              to="/extend-trials"
              class="nav-link cursor-pointer btn-noshadow side-button mx-2"
            >
            <font-awesome-icon
                class="fa-md cursor-pointer profile-pic"
                icon="star"
                style="color:#ffc107!important;margin-left: 11px;margin-right:5px;"
              />
              <span class="nav-text">{{ t('Extend Trial') }}</span>
            </router-link>
          </div>
          <!-- <div class="no-drag item">
          <router-link
            to="/logout"
            class="nav-link cursor-pointer btn-noshadow side-button mx-2"
          >
            <font-awesome-icon class="ml-2 mr-2" icon="sign-out-alt" />{{
              t('Logout')
            }}
          </router-link>
        </div> -->
        </template>
      </div>

      <div class="btm-container">
        <hr />
        <!-- <div class="no-drag item"> -->
        <!-- v-if="$isFreePlan.includes($session.get('paid_plan')) || $isLegacyFreePlan.includes($session.get('paid_plan')) || day2expire" -->

        <!-- <router-link
          tag="button"
          to="/dashboard"
          class="btn btn-third nav-link cursor-pointer text-center side-button"
      >Back to dashboard</router-link>-->
        <!-- </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { mixin as clickaway } from 'vue-clickaway'

/* eslint-disable */
export default {
  mixins: [clickaway],
  components: {},
  data: function () {
    return {
      contentStatus: '',
      isAdminRole: false,
      darkTheme: false,
      isHowuku: false,
      showEarn: true,
      freePlan:false,
      hasCustomDomain: false,
      excludedPlan: [104, 801, 802, 803],
      minimized: localStorage.getItem('sidebarMinimized') === 'true',
    }
  },
  mounted() {
    this.$http
      .get(process.env.API_ENDPOINT + '/getCompany')
      .then((response) => {
        let companyInfo = response.data[0]
        if (companyInfo.custom_domain !== '') {
          this.hasCustomDomain = true
        }
      })

    if(this.$session.get('is_pageview') === 1) this.showEarn = false;
    this.isHowuku =
      window.location.host === 'app.howuku.com' ||
      window.location.host.includes('localhost')
    if (!this.isHowuku) this.darkTheme = false // dark theme only for Howuku

    // Set initial sidebar width only if not Howuku
    if (this.$isMida) {
      const sidebarWidth = this.minimized ? '64px' : '240px';
      document.body.style.setProperty('--sidebar-width', sidebarWidth);
    }
  },
  beforeMount() {
    this.darkTheme = true
    this.freePlan = (this.$session.get('paid_plan') === 0)
    this.isAdminRole =
      this.$session.get('role') !== 3 && this.$session.get('role') !== 2
  },
  methods: {
    logout: function () {
      this.$router.push({ path: '/logout' })
    },
    toggleMinimize() {
      if (!this.$isMida) return;
      
      this.minimized = !this.minimized;
      localStorage.setItem('sidebarMinimized', this.minimized);
      
      if (this.minimized) {
        document.body.style.setProperty('--sidebar-width', '64px');
      } else {
        document.body.style.setProperty('--sidebar-width', '240px');
      }
    },
  },
}
</script>

<style scoped>

.minimize-btn {
  position: fixed;
  z-index: 999;
  left: calc(var(--sidebar-width) - 1px);
  cursor: pointer;
  background-color: white;
  padding: 8px 2px;
  border: 1px solid #ececef;
  border-left: 0px;
  top: calc(50% - 28px);
}

.nav-side-menu {
  width: var(--sidebar-width);
  transition: width 0.3s ease;
}

.nav-side-menu.minimized .nav-text {
  display: none;
}

.minimized .side-button span:not(.fa-layers),
.minimized .category-title {
  display: none;
}

.minimized .nav-link {
  padding: 0.5rem;
  justify-content: center;
  margin-bottom: 10px;
}

.minimized svg {
  font-size: 20px;
}

/* Add any additional styles needed for minimized state */
</style>



// WEBPACK FOOTER //
// src/layouts/menus/SettingMenu.vue